
import { CreateElement, VNode } from 'vue';
import { Component } from 'vue-property-decorator';

import FormBase from '../modules/FormBase'
import { Item } from '../modules/type';


@Component
export default class FormTs extends FormBase {

    public listLedgers: Dropdown[] = [];
    public fromLedgers: Dropdown[] = [];
    public listLabels: string[] = ['Debit', 'note', 'amount'];
    public fromLabels: string[] = ['Credit', 'Note', 'Amount'];





    params(): { fromList: Item[] | Error, list: Item[] | Error, [prop: string]: any } | Error {
        const { date, refNo, trNo, type, narration,branchId } = this;
        const fromList = this.costCenterBeforeSubmit(this.fromList, 'Paid to list');
        const list = this.costCenterBeforeSubmit(this.list, 'Paid From');
        const image_id = this.getImageId();
        return { fromList, list, date, refNo, trNo, type, narration ,branchId,image_id};
    }

    afterSubmit(): void {
        if(this.id){ //isEdit
            this.$router.push({name:"Transaction.journal.index"})
        }else{
            this.list = [];
            this.addRowTo();
            this.fromList = [];
            this.addRowFrom();
           this.saveAlert('journal')
        }
    }



    fromToRows(h: CreateElement, headers: DataTableHeader[]): VNode[] {
        return [this.listEls(h, this.listLedgers, headers), this.fromEls(h, this.fromLedgers, headers)]
    }

    fetchList(){
        this.fetchDropdown({ noUser: false, dropdown: true }, (collection: Dropdown[]) => {
            this.listLedgers = collection;
            this.fromLedgers = collection;
        })
    }

    created() {
        this.fetchCostCentres()
        if (this.id) { this.show() } else { this.isDotEdit() }

        this.fetchList();
      


    }


    render(h: CreateElement) {

        return this.renderEl(h)


    }





}